module.exports = __webpack_public_path__ + "img/boho_rio_gift_woman.a32c2aa5.svg";